module.exports = __webpack_public_path__ + "static/media/bg-hero.1920d4bc.jpg";